import axios from "axios";

// Получаем текущий поддомен
const hostname = window.location.hostname;
const subdomain = hostname.split(".")[0]; // Получить поддомен

// Настраиваем базовый URL с учетом поддомена
const apiClient = axios.create({
  //"baseURL": `http://${subdomain}.localhost:2000`, // Подставляем поддомен
  "baseURL": `https://${subdomain}.beelspace.com`,
  "headers": {
    "Content-Type": "application/json"
  }
});

export default apiClient;



// WEBPACK FOOTER //
// ./src/apiClient.js